import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import axe from '../../../services/axios-client/axiosClient';
import { downloadFile } from '../../../services/axios-client/axeHelpers';
import { generalAlertError } from '../../../common/utils/alerts';
import { SidebarCard } from '../AiProducts.styles';

function ProductAttachments({ attachments }) {
  const [downloadingId, setDownloadingId] = useState(null);

  if (!attachments || attachments.length === 0) {
    return null;
  }

  const download = async (attachment) => {
    setDownloadingId(attachment.id);
    try {
      const response = await axe.get(attachment.download_url, { responseType: 'blob' });
      if (response.status !== 200) {
        generalAlertError('Impossibile scaricare il documento');
        return;
      }
      downloadFile(response.data, `${attachment.name}.pdf`);
    } catch (error) {
      generalAlertError('Impossibile scaricare il documento');
    } finally {
      setDownloadingId(null);
    }
  };

  return (
    <div className="col-sm-12 col-md-4 col-lg-12 col-xl-12">
      <SidebarCard>
        <div className="d-flex align-items-center justify-content-between mb-2">
          <h6 className="m-0 fw-bold sidebar-title">Documenti da scaricare</h6>
          <span className="badge rounded-pill sidebar-count">{attachments.length}</span>
        </div>
        <ul className="list-unstyled m-0 d-grid gap-2">
          {attachments.map((attachment) => (
            <li key={attachment.id} className="attachment-row d-flex align-items-center gap-2 p-2 rounded-3">
              <FontAwesomeIcon icon={faFilePdf} className="attachment-icon" size="lg" />
              <div className="flex-grow-1 attachment-text">
                <p className="m-0 fw-semibold attachment-name text-truncate" title={attachment.name}>
                  {attachment.name}
                </p>
                {attachment.is_fillable && (
                  <span className="d-block attachment-hint">
                    Compila e caricalo tra i documenti richiesti
                  </span>
                )}
              </div>
              <button
                type="button"
                aria-label={`Scarica ${attachment.name}`}
                className="btn btn-sm btn-success rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                style={{ width: '32px', height: '32px' }}
                disabled={downloadingId === attachment.id}
                onClick={() => download(attachment)}
              >
                {downloadingId === attachment.id ? (
                  <span className="spinner-border spinner-border-sm" role="status">
                    <span className="visually-hidden">Scaricando...</span>
                  </span>
                ) : (
                  <FontAwesomeIcon icon={faDownload} />
                )}
              </button>
            </li>
          ))}
        </ul>
      </SidebarCard>
    </div>
  );
}

export default ProductAttachments;
